(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cta"] && !Shopify.designMode) return;
  try {
    (() => {
    const sync = (form) => {
      form.querySelectorAll('[data-cta]').forEach((button) => {
        button.disabled = !form.checkValidity();
      });
    };

    const init = () => {
      document.querySelectorAll('form').forEach((form) => {
        if (!form.querySelector('[data-cta]') || form.dataset.ctaReady) return;
        form.dataset.ctaReady = 'true';
        sync(form);
        form.addEventListener('input', () => sync(form));
        form.addEventListener('change', () => sync(form));
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
